(() => {
  const translations = new Map([
    ['Description', 'A\u00e7\u0131klama'],
    ['Additional information', 'Ek Bilgiler'],
    ['Details', 'Detaylar'],
    ['Reviews', 'Yorumlar'],
    ['Shop', 'Ma\u011faza'],
    ['Wishlist', 'Favoriler'],
    ['Cart', 'Sepet'],
    ['Account', 'Hesab\u0131m'],
    ['Search', 'Ara'],
    ['Tax included.', 'Vergi dahildir.'],
    ['Add to cart', 'Sepete Ekle'],
    ['Buy it now', '\u015eimdi Sat\u0131n Al'],
    ['Sold out', 'T\u00fckendi']
  ]);

  const translate = (root = document) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach((textNode) => {
      const label = textNode.nodeValue.trim();
      const translated = translations.get(label);
      if (translated) textNode.nodeValue = textNode.nodeValue.replace(label, translated);
    });
  };

  const start = () => {
    translate();
    new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) translate(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
